// PROD-3310 billing bridge.
// Mirrors: dev-scrips-pm-react src/components/ui/textarea.tsx (a native `<textarea>` on PM's FIELD_LOOK,
// `field-sizing-content min-h-16`; every native textarea prop passes through).
// Wraps:   Signal DS `TextArea` (the field look is the DS field, restyled app-wide by `src/styles/showcase-bridge.css`
// "Input: one field look ... TextArea").
// Overrides: none beyond the name; `autoGrow` stands in for PM's `field-sizing-content`.
import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { TextArea } from '@scripsteam/scrips-signal-ds';

export type TextareaProps = Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'rows' | 'dir'> & {
  rows?: number;
  dir?: 'ltr' | 'rtl';
};

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(props, ref) {
  return <TextArea ref={ref} data-slot="textarea" autoGrow {...props} />;
});
